import requset from "utils/request";
import { CONSUME, CDNCONSUME } from "apiurl/index.js";
export function payMoney(params) {
  return requset({
    url: `${CONSUME}/core/pay/order/ali`,
    method: "POST",
    params
  });
}
export function wxpayMoney(params) {
  return requset({
    url: `${CONSUME}/core/pay/order/wx`,
    method: "POST",
    params
  });
}

export function payMoneyList(params) {
  return requset({
    url: `${CDNCONSUME}/core/pay/cdn/grade`,
    method: "GET",
    params
  });
}
export function paySuccess(params) {
  return requset({
    url: `${CONSUME}/core/pay/query/order`,
    method: "GET",
    params
  });
}
export function payOrder(params) {
  return requset({
    url: `${CONSUME}/core/pay/list/order`,
    method: "GET",
    params
  });
}

/* ===消费记录 */
export function groupPay(params) {
  return requset({
    url: `${CONSUME}/record/list/group/type`,
    method: "GET",
    params
  });
}
// 二级
export function groupbook(params) {
  return requset({
    url: `${CONSUME}/record/list/group/book`,
    method: "GET",
    params
  });
}
// 三级
export function bookRecord(params) {
  return requset({
    url: `${CONSUME}/record/list/book`,
    method: "GET",
    params
  });
}
/* 找回订单 */

export function payisSuccess(params) {
  return requset({
    url: `${CONSUME}/core/pay/order/retrieve`,
    method: "POST",
    params
  });
}
